<template>
  <div id="app">
    <!-- 加载屏幕 -->
    <LoadingScreen v-if="isLoading" @loaded="handleLoaded" />
    
    <!-- 主要内容 -->
    <div v-else class="app-container">
      <!-- 导航栏 -->
      <Navbar />

      <!-- 路由视图 -->
      <main class="main-content">
        <router-view v-slot="{ Component }">
          <transition name="page" mode="out-in">
            <component :is="Component" :key="$route.fullPath" />
          </transition>
        </router-view>
      </main>

      <!-- 页脚 -->
  <Footer />
  <AudioPlayer />
  <CornerFigure />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import LoadingScreen from '@/components/LoadingScreen.vue'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import AudioPlayer from '@/components/AudioPlayer.vue'
import CornerFigure from '@/components/CornerFigure.vue'
// 移除复杂的页脚/粒子/返回顶部，保持博客风格简洁

export default {
  name: 'App',
  components: {
    LoadingScreen,
    Navbar,
  Footer,
  AudioPlayer,
  CornerFigure,
    
  },
  setup() {
    const isLoading = ref(true)

    const handleLoaded = () => {
      isLoading.value = false
    }

    onMounted(() => {
      // 缩短模拟加载时间
      setTimeout(() => {
        if (isLoading.value) {
          handleLoaded()
        }
      }, 800)
    })

    return {
      isLoading,
      handleLoaded
    }
  }
}
</script>

<style lang="scss">
.app-container {
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.main-content {
  flex: 1; // 占据剩余空间，确保 Footer 贴底
  min-height: 0; // 避免子元素因高度计算产生额外滚动
  background: #fff; // 保持主体为白色，避免底部出现浅灰底色
}

// 页面切换动画
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
